import { useState } from "react";
import { useLocation } from "wouter";
import { useKeyboardShortcuts } from "@/hooks/useKeyboardShortcuts";
import { CommandPalette } from "./CommandPalette";
import { HelpModal } from "./HelpModal";
import { useTheme } from "@/contexts/ThemeContext";

/**
 * Global keyboard shortcuts that work across the entire app
 */
export function GlobalKeyboardShortcuts() {
  const [, setLocation] = useLocation();
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);
  const { toggleTheme, switchable } = useTheme();

  useKeyboardShortcuts([
    // Search shortcuts
    {
      key: "k",
      ctrl: true,
      description: "ເປີດການຄົ້ນຫາ",
      handler: () => {
        setCommandPaletteOpen(true);
      },
    },
    {
      key: "/",
      description: "ໂຟກັດໃສ່ການຄົ້ນຫາ",
      handler: () => {
        setCommandPaletteOpen(true);
      },
    },
    // Theme toggle
    ...(switchable
      ? [
          {
            key: "t",
            alt: true,
            description: "ປ່ຽນ Dark/Light Mode",
            handler: () => {
              toggleTheme?.();
            },
          },
        ]
      : []),
    // Navigation shortcuts
    {
      key: "d",
      alt: true,
      description: "ໄປໜ້າ Dashboard",
      handler: () => {
        setLocation("/dashboard");
      },
    },
    {
      key: "c",
      alt: true,
      description: "ໄປລາຍການລູກຄ້າ",
      handler: () => {
        setLocation("/customers-list");
      },
    },
    {
      key: "l",
      alt: true,
      description: "ໄປຄຳຂໍສິນເຊື່ອ",
      handler: () => {
        setLocation("/loan-applications");
      },
    },
    {
      key: "n",
      ctrl: true,
      description: "ເພີ່ມລູກຄ້າໃໝ່",
      handler: () => {
        setLocation("/add-customer");
      },
    },
    {
      key: "r",
      alt: true,
      description: "ໄປລາຍງານ",
      handler: () => {
        setLocation("/reports");
      },
    },
    {
      key: "s",
      alt: true,
      description: "ໄປຕັ້ງຄ່າ",
      handler: () => {
        setLocation("/settings/system");
      },
    },
    {
      key: "?",
      shift: true,
      description: "ສະແດງ Keyboard Shortcuts",
      handler: () => {
        // HelpModal handles this internally
        const event = new KeyboardEvent("keydown", {
          key: "?",
          shiftKey: true,
          bubbles: true,
        });
        document.dispatchEvent(event);
      },
    },
  ]);

  return (
    <>
      <CommandPalette open={commandPaletteOpen} onOpenChange={setCommandPaletteOpen} />
      <HelpModal />
    </>
  );
}
